import { useEffect } from "react";
import { supabase } from "@/lib/supabase";

function getISOWeek(): string {
  const now = new Date();
  const year = now.getFullYear();
  const startOfYear = new Date(year, 0, 1);
  const weekNum = Math.ceil(((now.getTime() - startOfYear.getTime()) / 86400000 + startOfYear.getDay() + 1) / 7);
  return `${year}-W${String(weekNum).padStart(2, "0")}`;
}

export function useWeeklyStreak() {
  useEffect(() => {
    const checkStreak = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const currentWeek = getISOWeek();
      const { data: profile } = await supabase
        .from("profiles")
        .select("last_login_week, weekly_streak, score")
        .eq("id", user.id)
        .maybeSingle();

      if (!profile) return;

      if (profile.last_login_week === currentWeek) return; // already logged in this week

      // Calculate previous week
      const [yearStr, weekStr] = (profile.last_login_week || "").split("-W");
      const prevYear = parseInt(yearStr || "0");
      const prevWeek = parseInt(weekStr || "0");
      const nowYear = parseInt(currentWeek.split("-W")[0]);
      const nowWeek = parseInt(currentWeek.split("-W")[1]);

      const isConsecutive =
        (nowYear === prevYear && nowWeek === prevWeek + 1) ||
        (nowYear === prevYear + 1 && prevWeek >= 52 && nowWeek === 1);

      const newStreak = isConsecutive ? (profile.weekly_streak || 0) + 1 : 1;
      const streakBonus = newStreak % 4 === 0 ? 80 : 0; // bonus every 4 weeks
      const newScore = (profile.score || 0) + 10 + streakBonus;

      await supabase.from("profiles").update({
        last_login_week: currentWeek,
        weekly_streak: newStreak,
        score: newScore,
      }).eq("id", user.id);
    };

    checkStreak();
  }, []);
}
